import React from 'react';
import {
  Card, Typography, Box, CardContent, CardActions, makeStyles, createStyles,
} from '@material-ui/core';

interface GenericCardProps {
  children?: React.ReactNode,
  primaryText: string,
  secondaryText?: string,
  tertiaryText?: string,
  buttonContent?: React.ReactNode;
  textColor? : 'success' | 'failure',
}

const useStyles = makeStyles(() => createStyles({
  successText: {
    color: '#6CAE75',
  },
  failureText: {
    color: '#EF5350',
  },
  noColor: {

  },
}));

const GenericCard: React.FC<GenericCardProps> = ({

  primaryText = 'Current Repair', secondaryText, tertiaryText, children, buttonContent, textColor,
}) => {
  const classes = useStyles();
  // eslint-disable-next-line no-nested-ternary
  const textClass = textColor === 'success' ? 'successText' : textColor === 'failure' ? 'failureText' : 'noColor';
  return (
    <Card style={{ height: '100%' }}>
      <Box p={2}>
        <Box pl={2}>
          { children }
          <Typography variant="h6">
            {primaryText}
          </Typography>
        </Box>
        { (secondaryText || tertiaryText)
        && (
        <CardContent>
          <Typography variant="h4" className={`${classes[textClass]}`}>
            {secondaryText}
          </Typography>
          <Typography color="textSecondary">
            {tertiaryText}
          </Typography>
        </CardContent>
        )}
      </Box>
      { buttonContent
      && (
        <Box p={1}>
          <CardActions>
            {buttonContent}
          </CardActions>
        </Box>
      )}
    </Card>
  );
};

export default GenericCard;
